import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, unref as _unref, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo-tarif.png'


const _withScopeId = n => (_pushScopeId("data-v-692b5eb6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "middle"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "loader-container" }
const _hoisted_4 = {
  key: 1,
  class: "middle"
}
const _hoisted_5 = {
  key: 0,
  class: "container"
}
const _hoisted_6 = { "aria-label": "breadcrumb" }
const _hoisted_7 = { class: "breadcrumb" }
const _hoisted_8 = { class: "breadcrumb-item" }
const _hoisted_9 = {
  class: "breadcrumb-item active",
  "aria-current": "page"
}
const _hoisted_10 = {
  key: 1,
  class: "description-tarif-group"
}
const _hoisted_11 = { class: "container" }
const _hoisted_12 = { class: "description-tarif" }
const _hoisted_13 = { class: "description-tarif-head" }
const _hoisted_14 = { class: "group-logo-tarif" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("figure", { class: "logo-image" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "#" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: ""
    })
  ])
], -1))
const _hoisted_16 = { class: "data-tarif-item" }
const _hoisted_17 = { class: "gb-info-tarif" }
const _hoisted_18 = { class: "prise-tarif" }
const _hoisted_19 = { class: "price-main" }
const _hoisted_20 = { class: "description-tarif-content" }
const _hoisted_21 = { class: "tarif-content" }
const _hoisted_22 = { class: "tarif-content" }
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = { class: "description-tarif-bot" }
const _hoisted_25 = { class: "description-tarif-bot-item" }
const _hoisted_26 = { class: "checkbox-group" }
const _hoisted_27 = { for: "check" }
const _hoisted_28 = {
  key: 0,
  class: "checkbox-group"
}
const _hoisted_29 = { for: "promo-subscribe" }
const _hoisted_30 = { class: "description-tarif-bot-item mt-3" }
const _hoisted_31 = { class: "group-tarif-bot-item" }
const _hoisted_32 = ["disabled"]
const _hoisted_33 = { style: {"display":"flex","align-items":"center","flex-direction":"column","gap":"5px"} }
const _hoisted_34 = { style: {"display":"flex","align-items":"center","justify-content":"center","gap":"5px"} }
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { key: 1 }
const _hoisted_37 = {
  key: 0,
  style: {"font-size":"12px"}
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "description-tarif-bot-item__text" }, " VAT may apply. Based on your location ", -1))
const _hoisted_39 = {
  key: 0,
  class: "row mt-3"
}
const _hoisted_40 = { style: {"width":"auto"} }
const _hoisted_41 = {
  key: 1,
  class: "row mt-3"
}
const _hoisted_42 = { style: {"width":"auto"} }
const _hoisted_43 = {
  key: 2,
  class: "data-plans-group other-plans"
}
const _hoisted_44 = { class: "container" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Additional plans", -1))
const _hoisted_46 = { class: "other-plans-loader-wrapper" }
const _hoisted_47 = { class: "data-plans-slider" }

import {
  computed,
  ComputedRef,
  nextTick,
  onBeforeUnmount,
  onMounted,
  ref,
  Ref,
  watch,
} from "vue";
import { Bundle, useBundleStore } from "@/stores/bundle";
import BundleCountries from "@/components/bundle/BundleCountries.vue";
import { useDataStore } from "@/stores/data";
import BundleCard from "@/components/bundle/BundleCard.vue";
import MainLoader from "@/components/MainLoader.vue";
import { useAppStore } from "@/stores/app";
import PopupDevices from "@/components/popups/PopupDevices.vue";
import { useUserStore } from "@/stores/user";
import router from "@/router";
import { getCookie, requestedCountriesFromUrl } from "@/helpers";
import { useEsimStore } from "@/stores/esim";
import PopupBundleInfoLoading from "@/components/popups/PopupBundleInfoLoading.vue";
import PopupPromo from "@/components/popups/PopupPromo.vue";
import PopupPromoTerms from "@/components/popups/PopupPromoTerms.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'BundleDetails',
  props: {
  id: String,
},
  setup(__props) {

const props = __props;

const appStore = useAppStore();
const dataStore = useDataStore();
const bundleStore = useBundleStore();
const esimStore = useEsimStore();
const userStore = useUserStore();

const bundleId: ComputedRef<string> = computed(() => String(props.id));
const bundle: ComputedRef<Bundle | undefined> = computed(() =>
  bundleStore.bundles.find((b: Bundle) => b.id === bundleId.value)
);

const compatibilityConfirm: Ref<boolean> = ref(false);
const countriesOpened: Ref<boolean> = ref(false);
const detailsOpened: Ref<boolean> = ref(false);
const bundleInfoError: Ref<boolean> = ref(false);
const buyLoading: Ref<boolean> = ref(false);
const promoSubscriptioned: Ref<boolean> = ref(false);

const otherBundles: ComputedRef<Bundle[]> = computed(() => {
  const bundles = bundle.value?.otherBundles
    ? [...bundle.value?.otherBundles]
    : [];
  const currentBundleIndex = bundles.findIndex(
    (b: Bundle) => b.id === bundle.value?.id
  );
  if (currentBundleIndex >= 0) {
    bundles.splice(currentBundleIndex, 1);
  }
  return bundles;
});

const bundlePriceWithCashback: ComputedRef<number> = computed(() =>
  Math.round(
    bundle.value.price -
      (esimStore.useCashback
        ? maxUsedCashback.value
        : esimStore.activePromo
        ? bundle.value?.price * esimStore.activePromo.discountPercent
        : 0)
  )
);

const maxUsedCashback: ComputedRef<number> = computed(() => {
  const userCashback: number = userStore.cashback;

  const maxBundle: number = Math.round(
    (bundle.value.price / 100) *
      (100 - dataStore.minTransactionPriceWithCashbackPercents)
  );

  if (maxBundle > userCashback) {
    return userCashback;
  }

  return maxBundle;
});

const showPromoPopup = (): void => {
  appStore.showPopup({
    component: PopupPromo,
    props: { bundlePrice: bundle.value?.price ?? 0 },
  });
};

async function buyBundle(): Promise<void> {
  buyLoading.value = true;

  if (!userStore.isAuth) {
    await router.push(`/?bundleId=${bundleId.value}#auth`);
  } else {
    try {
      if (promoSubscriptioned.value && !userStore.promoSubscribed) {
        userStore.promoSubscribed = true;
      }
      // eslint-disable-next-line no-empty
    } catch (e) {}

    const bundleInfoCheck: boolean = await bundleStore.checkBundleInfo(
      bundleId.value
    );
    if (bundleInfoCheck) {
      try {
        const url: string | null = await esimStore.buyEsim(
          bundleId.value,
          requestedCountriesFromUrl(),
          window.location.href,
          esimStore.useCashback.value,
          esimStore.activePromo?.code
        );
        if (typeof url === "string" && url !== "undefined") {
          window.open(url, "_self");
        } else {
          await router.push("/payment-disabled");
          return;
        }
      } catch (e) {
        await router.push("/payment-disabled");
        return;
      }
    } else {
      bundleInfoError.value = true;
    }
  }

  buyLoading.value = false;
}

const getBundle = async (): Promise<Bundle | null> => {
  const requestedCountriesIds = requestedCountriesFromUrl().map((c) => c.id);

  if (!requestedCountriesIds.length) {
    await router.push("/");
    return;
  }

  let response;

  try {
    response = await bundleStore.getBundleById(
      bundleId.value,
      requestedCountriesIds
    );
    // eslint-disable-next-line no-empty
  } catch (e) {}

  if (!response) {
    bundleInfoError.value = true;
    return;
  }
  changeMeta();
};

onBeforeUnmount(() => (esimStore.activePromo = undefined));

onMounted(async () => {
  await getBundle();
  changeMeta();

  if (!userStore.isAuth) {
    return router.push(
      `/?bundleId=${bundle.value?.id}&requestedCountries=${JSON.stringify(
        requestedCountriesFromUrl().map((c) => c.iso)
      )}#auth`
    );
  }

  // Check cookie promocode
  try {
    const cookiePromo = getCookie("toosim-promocode");
    if (!cookiePromo || typeof cookiePromo?.promocode !== "string") return;
    esimStore.activePromo = await esimStore.checkPromoIsValid(
      cookiePromo.promocode
    );
    // eslint-disable-next-line no-empty
  } catch (e) {}
});
watch(bundleId, getBundle);

function changeMeta(): void {
  const text = `eSIM: ${
    bundle.value?.duration
  } days, ${bundle.value?.dataAmountGb()} GB, ${requestedCountriesFromUrl()
    .map((c) => c.name)
    .join(", ")} | Toosim`;
  document.title = text;
  document
    .querySelector('meta[name="description"]')
    .setAttribute("content", text);
}

function goOtherBundle(bundleId: string): void {
  router.push();
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (!bundle.value && !bundleInfoError.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(MainLoader, { primary: "" })
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
        _createVNode(_Transition, { name: "fade" }, {
          default: _withCtx(() => [
            (buyLoading.value || bundleInfoError.value)
              ? (_openBlock(), _createBlock(PopupBundleInfoLoading, {
                  key: 0,
                  error: bundleInfoError.value
                }, null, 8, ["error"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        (bundle.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("nav", _hoisted_6, [
                _createElementVNode("ol", _hoisted_7, [
                  _createElementVNode("li", _hoisted_8, [
                    _createVNode(_component_router_link, { to: "/" }, {
                      default: _withCtx(() => [
                        _createTextVNode("eSIM Store")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", _hoisted_9, " Plan " + _toDisplayString(bundle.value.dataAmountGb()) + "gb " + _toDisplayString(bundle.value.duration) + " days ", 1)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (bundle.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _hoisted_15,
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          _createTextVNode(_toDisplayString(bundle.value.dataAmountGb()) + " GB ", 1),
                          _createElementVNode("span", null, _toDisplayString(bundle.value.duration) + " days", 1)
                        ]),
                        _createVNode(BundleCountries, {
                          countries: bundle.value.countries,
                          "requested-countries": _unref(requestedCountriesFromUrl)(),
                          "view-button": ""
                        }, null, 8, ["countries", "requested-countries"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("span", _hoisted_19, "$ " + _toDisplayString(bundle.value.priceUsd()), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["description-tarif-content-item", { active: countriesOpened.value }])
                    }, [
                      _createElementVNode("h6", {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (countriesOpened.value = !countriesOpened.value))
                      }, " Supported countries "),
                      _createElementVNode("div", _hoisted_21, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bundle.value.countries, (country, index) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: index,
                            style: _normalizeStyle(
                    _unref(requestedCountriesFromUrl)()
                      .map((c) => c.iso)
                      .includes(country.iso)
                      ? 'font-weight: bold'
                      : ''
                  )
                          }, _toDisplayString(`${country.name}${
                      bundle.value.countries.length > 1 &&
                      index < bundle.value.countries.length - 1
                        ? ", "
                        : ""
                    }`), 5))
                        }), 128))
                      ])
                    ], 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(["description-tarif-content-item", { active: detailsOpened.value }])
                    }, [
                      _createElementVNode("h6", {
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (detailsOpened.value = !detailsOpened.value))
                      }, " Terms & Conditions "),
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("p", {
                          innerHTML: _unref(dataStore).termsText
                        }, null, 8, _hoisted_23)
                      ])
                    ], 2)
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((compatibilityConfirm).value = $event)),
                          type: "checkbox",
                          id: "check"
                        }, null, 512), [
                          [_vModelCheckbox, compatibilityConfirm.value]
                        ]),
                        _createElementVNode("label", _hoisted_27, [
                          _createElementVNode("span", null, [
                            _createTextVNode(" I confirm my device is eSIM "),
                            _createElementVNode("button", {
                              class: "button-link",
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(appStore).showPopup({ component: PopupDevices })))
                            }, " compatible ")
                          ])
                        ])
                      ])
                    ]),
                    (!_unref(userStore).promoSubscribed)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            id: "promo-subscribe",
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((promoSubscriptioned).value = $event))
                          }, null, 512), [
                            [_vModelCheckbox, promoSubscriptioned.value]
                          ]),
                          _createElementVNode("label", _hoisted_29, [
                            _createElementVNode("span", null, [
                              _createTextVNode(" Inform me about new promotions and tips. "),
                              _createElementVNode("button", {
                                class: "button-link",
                                onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (
                      _unref(appStore).showPopup({ component: PopupPromoTerms })
                    ), ["prevent"]))
                              }, " Read more ")
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("button", {
                          class: "btn btn-b btn-max btn-danger",
                          onClick: buyBundle,
                          disabled: !compatibilityConfirm.value
                        }, [
                          _createElementVNode("span", _hoisted_33, [
                            _createElementVNode("span", _hoisted_34, [
                              _createElementVNode("span", {
                                style: _normalizeStyle(
                          _unref(esimStore).useCashback || _unref(esimStore).activePromo
                            ? 'text-decoration: line-through; transition: 0.2s;'
                            : 'transition: 0.2s;'
                        )
                              }, " $" + _toDisplayString(bundle.value.priceUsd()), 5),
                              _createVNode(_Transition, { name: "fadeHeight" }, {
                                default: _withCtx(() => [
                                  (_unref(esimStore).activePromo)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_35, " $" + _toDisplayString((
                              Math.round(
                                bundle.value.price -
                                  bundle.value.price *
                                    _unref(esimStore).activePromo.discountPercent
                              ) / 100
                            ).toLocaleString("en-US")), 1))
                                    : (_unref(esimStore).useCashback)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_36, " $" + _toDisplayString((bundlePriceWithCashback.value / 100).toLocaleString(
                              "en-US"
                            )), 1))
                                      : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }),
                              _createTextVNode(" - Buy now ")
                            ]),
                            (
                        _unref(dataStore).cashbackEnabled &&
                        _unref(dataStore).cashbackMaxPercent > 0
                      )
                              ? (_openBlock(), _createElementBlock("span", _hoisted_37, " Get $" + _toDisplayString((
                          Math.round(
                            bundlePriceWithCashback.value *
                              _unref(dataStore).cashbackMaxPercent
                          ) / 100
                        ).toLocaleString("en-US")) + " in rewards for next purchase ", 1))
                              : _createCommentVNode("", true)
                          ])
                        ], 8, _hoisted_32)
                      ]),
                      _hoisted_38,
                      (_unref(esimStore).activePromo)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                            _createElementVNode("div", _hoisted_40, _toDisplayString(Math.round(_unref(esimStore).activePromo?.discountPercent * 100)) + "% discount applied ", 1),
                            _createElementVNode("button", {
                              onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(esimStore).activePromo = null)),
                              class: "text-button",
                              style: {"color":"#330fbd","width":"auto"}
                            }, " remove ")
                          ]))
                        : (_unref(esimStore).useCashback)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                              _createElementVNode("div", _hoisted_42, " $" + _toDisplayString((maxUsedCashback.value / 100).toLocaleString("en-US")) + " in rewards applied ", 1),
                              _createElementVNode("button", {
                                onClick: _cache[7] || (_cache[7] = ($event: any) => (_unref(esimStore).useCashback = false)),
                                class: "text-button",
                                style: {"color":"#330fbd","width":"auto"}
                              }, " remove ")
                            ]))
                          : (_openBlock(), _createElementBlock("button", {
                              key: 2,
                              onClick: showPromoPopup,
                              class: "text-button mt-3 open-promo-popup-button",
                              style: {"text-decoration":"underline","color":"#828282","font-size":"15px"}
                            }, " Use promo code" + _toDisplayString(_unref(dataStore).showCashback ? " or rewards" : ""), 1))
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (bundle.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
              _createElementVNode("div", _hoisted_44, [
                _hoisted_45,
                _createElementVNode("div", _hoisted_46, [
                  (!bundleInfoError.value && !otherBundles.value.length)
                    ? (_openBlock(), _createBlock(MainLoader, {
                        key: 0,
                        primary: ""
                      }))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_47, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(otherBundles.value, (b) => {
                    return (_openBlock(), _createBlock(BundleCard, {
                      key: b.id,
                      bundle: b,
                      "requested-countries": _unref(requestedCountriesFromUrl)()
                    }, null, 8, ["bundle", "requested-countries"]))
                  }), 128))
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
}
}

})